import React from "react"
import styled from "styled-components"
import tinycolor from "tinycolor2"

import {IconButton} from "@irati/ui/src/Button"
import IconWrapper from "./IconWrapper"
import {ColorCss} from "./styled"

const CustomColorPreview = styled.div`
  ${ColorCss}
  padding: 8px;
  border: ${({isValidHex, color}) => ((isValidHex && color) ? "none" : "2px dashed #909090")} ;
  background-color: ${({isValidHex, color}) => ((isValidHex && color) ? color : "white")};
  color: ${({isValidHex, color}) => ((isValidHex && color) && !tinycolor(color).isLight() ? "white" : "black")};
  ${({isAnySelected, selected}) => ((isAnySelected && !selected) && "opacity: 0.5;")}
`

interface Props {
  onClick: () => void,
  selected: boolean,
  isValidHex: boolean,
  color: string
}

const CustomColorPreviewItem = (props: Props) => (
  <>
    <CustomColorPreview small {...props} />
    <IconWrapper
      onClick={props.onClick}
      hide={!props.selected || !props.isValidHex}>
      <IconButton
        inline
        icon="tick"
        onClick={() => {}}
        color={tinycolor(props.color).isLight() ? "black" : "white"} />
    </IconWrapper>
  </>
)

export default CustomColorPreviewItem
